import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import trans from '~/translations/trans'
import DatePicker from '~/components/common/DatePicker'

type Filter = {
  dateFrom: string | null
  dateTo: string | null
}

type Props = {
  search: string
  setSearch: (search: string) => void
  filter: any
  setFilter: React.Dispatch<React.SetStateAction<any>>
  small?: boolean
}

const Search: React.FC<Props> = ({
  search,
  setSearch,
  filter,
  setFilter,
  small = false,
}) => {
  return (
    <>
      <div
        className={classNames('filterSearch', {
          'filterSearch--small': small,
        })}
      >
        <div className="field filterSearch-search">
          <p className="control has-icons-left has-icons-right">
            <input
              className="input is-rounded filterSearch-search-input"
              type="text"
              placeholder={trans.list.search()}
              autoFocus={true}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <span className="icon is-small is-left filterSearch-search-icon">
              <i className="far fa-search"></i>
            </span>
          </p>
        </div>
        <div className="filterSearch-date">
          <DatePicker filter={filter} setFilter={setFilter} />
        </div>
      </div>
    </>
  )
}

export default Search
